import { render, staticRenderFns } from "./DigitalOrderShipment.vue?vue&type=template&id=206b1d90&scoped=true"
import script from "./DigitalOrderShipment.vue?vue&type=script&lang=js"
export * from "./DigitalOrderShipment.vue?vue&type=script&lang=js"
import style0 from "./DigitalOrderShipment.vue?vue&type=style&index=0&id=206b1d90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206b1d90",
  null
  
)

export default component.exports